import { Link } from "react-router-dom";
import { LogoMark } from "../brand/Logo";
import { services } from "../../content/services";

const Row = ({ hidden = false }) => (
  <ul className="tc-marquee-row flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {services.map((s, i) => (
      <li key={s.slug} className="flex shrink-0 items-center">
        <Link to={`/services/${s.slug}`} tabIndex={hidden ? -1 : undefined} data-testid={hidden ? undefined : `marquee-link-${s.slug}`}
          className={`whitespace-nowrap rounded-md px-5 font-display text-[1.375rem] font-medium leading-[1.2] tracking-tight outline-none transition-colors duration-300 hover:text-orange-500 focus-visible:text-orange-500 focus-visible:ring-2 focus-visible:ring-orange-500/70 sm:px-8 sm:text-[2rem] lg:px-10 lg:text-[2.75rem] ${i % 2 ? "text-stone-400" : "text-stone-100"}`}>
          {s.name}
        </Link>
        <LogoMark className="h-6 w-auto shrink-0 opacity-90 sm:h-8 lg:h-10" />
      </li>
    ))}
  </ul>
);

export const Marquee = () => (
  <section aria-label="Our eight service disciplines" data-testid="services-marquee"
    className="tc-marquee-wrap relative z-0 w-full max-w-full overflow-hidden border-y border-white/10 bg-[#0C0A09] py-8 [contain:paint] sm:py-11 lg:py-12">
    <div className="tc-marquee flex w-max" data-testid="services-marquee-track">
      <Row />
      <Row hidden />
    </div>
    <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-[#0C0A09] to-transparent sm:w-20" />
    <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-[#0C0A09] to-transparent sm:w-20" />
  </section>
);
